/**
 * RESPONSIBILITY: the band that sends people to the channel for older sermons.
 */
import type { SermonsArchiveSection } from '@app/sections';

export function SermonsArchive({ c }: { c: SermonsArchiveSection }) {
  return (
    <section className="band band-sand">
      <div className="wrap split split-reverse">
        <div className="stack">
          <h2>{c.archiveHeading}</h2>
          {c.archiveBody && <p className="lede">{c.archiveBody}</p>}
        </div>
        <div className="btns btns-end">
          <a className="btn" href={c.channelUrl || '#'}>{c.archiveLabel}</a>
        </div>
      </div>
    </section>
  );
}
